var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.82 10",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #04c7d8;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Next",
    className: "cls-1",
    d: "M281.287,405.321l5.69-5.694a1.591,1.591,0,1,0-2.251-2.249l-6.768,6.773c-.016.015-.034.025-.05.04a1.6,1.6,0,0,0,0,2.26c.015.015.034.026.05.04l6.768,6.773a1.591,1.591,0,1,0,2.251-2.249Z",
    transform: "translate(-396.911 287.443) rotate(-90)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/down-arrow.93edf89c6a9aae2c3efc79f59e6459a9.svg";